import apiClient from '@app/config/axios.config'
import { LayerSuitabilityRecord, UpdateLayerSuitabilityPayload } from '../types'

export const fetchLayerSuitability = async (
  layerId: string,
  signal?: AbortSignal,
): Promise<LayerSuitabilityRecord[]> => {
  const { data } = await apiClient.get<LayerSuitabilityRecord[]>(`/layers/${layerId}/suitability`, {
    signal,
  })
  return data
}

export const upsertLayerSuitability = async (
  layerId: string,
  useCaseSlug: string,
  payload: UpdateLayerSuitabilityPayload,
): Promise<LayerSuitabilityRecord> => {
  const { data } = await apiClient.put<LayerSuitabilityRecord>(
    `/layers/${layerId}/suitability/${useCaseSlug}`,
    payload,
  )
  return data
}

export const deleteLayerSuitability = async (
  layerId: string,
  useCaseSlug: string,
): Promise<void> => {
  await apiClient.delete(`/layers/${layerId}/suitability/${useCaseSlug}`)
}
